import { Dropdown } from 'antd'
import {
  ActionMenu,
  ItemText,
  SmallButtons,
} from 'components/ActionStyles/ActionStyles'
import Button from 'components/Button/index'
import RoutePath from 'components/RoutePath'
import DownArrowSolid from 'components/icons/DownArrowSolid'
import LeftArrow from 'components/icons/LeftArrow'
import VerticalThreeDots from 'components/icons/VerticalThreeDots'
import { ExternalDriveTable } from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ExternalAssesment/index.js'
import IndividualDriveTable from 'modules/Drives/ViewDriveRole/IndividualDriveTable/index'
import DownlaodUpload from 'modules/Exp-Candidates/DownloadAndUpload/index'
import AddInterviewer from 'modules/Exp-Candidates/ViewDriveRole/AddInterviewerDrawer/index'
import BulkActionDrawer from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/index'
import Metrics, {
  roleMenu,
} from 'modules/Exp-Candidates/ViewDriveRole/Header/Metrics'
import {
  BulkUploadDiv,
  CandidatesSpan,
  DropDown,
  LeftSection,
  PaddedDiv,
  RoleNameDiv,
  RoleNameFlex,
  SectionName,
  SectionWrapper,
  StyledTab,
  TopEndFlex,
  TopHeader,
} from 'modules/Exp-Candidates/ViewDriveRole/Style/style'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { getZeroBeforeInt } from 'utils/getZeroBeforeInt'
import {
  EmptyAnchor,
  EmptyElement,
} from '../../../components/UIComponents/CommonStyledDiv'
import { permittedSubEvents } from '../../../utils/permissionsValidation'
import CandidateDetailDrawer from '../../Exp-Candidates/ViewDriveRole/CandidateDocumnets/InterviewerDrawer/index'
import ShortListDrawer from './IndividualDriveTable/ShortListPopUp'
import AddRoundForm from './ManageInterviewerDrawer/AddRound'
import ManageInterviewDrawer from './ManageInterviewerDrawer/index'

const { TabPane } = StyledTab

const ViewIndividualDrive = ({
  driveRolesMetrics,
  getDriveRoleMetrics,
  getDriveRoleCandidatesList,
  getRoleMetrics,
  rolesMetrics,
  getDegreeAndDepartMent,
  degreeList,
  getIndidualDriveData,
  driveData,
  createInterview,
  driveInterViewerList,
  getDriveInterviewerList,
  getcollegeList,
  collegeList,
  getCandidateDetails,
  candidateDetails,
  getSingleCandidateInterviewDetails,
  candidateInterviewDetails,
  getGroupDiscussionList,
  getGroupCandidateList,
  groupList,
  groupCandidateList,
  getInterViewLocation,

  getInterviewerList,
  interViewerList,
  deleteInterviewer,
  updateInterviewStatus,
  addInterviewer,
  updateInterview,
  getCities,
  cityList,
  releaseOfferAPI,
  getSingleRoleData,
  singleRoleData,
  getRoleRounds,
  roleRoundsList,
  updateRoleRounds,
  requestDocumentList,
  getRequestDocument,
  requestCandidateDocuments,
  singleLocationData,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  listOfCountries,
  listOfStates,
  listOfCities,
  getCorporateLocationsList,
  corporateLocationsList,
  deleteLocationAPI,
  getLocationDetails,
  addCorporateBranch,
  getCandidateDocumentsList,
  canditateDocumentList,
  getCandidateDocumentsMetrices,
  canditateDocumentMetrices,
  fileUpload,
  getCandidateScoreList,
  postShortlistCandidates,
  getTopicsList,
  postPassingScore,
  getNewDriveFreshersList,
  newFreshersListData,
  getNewDriveStatus,
  newDriveStatusData,
  getNewDriveScore,
  newDriveScoreData,
  getNewIndividualDriveStatus,
  newDriveScore,
  getPanelList,
}) => {
  const tableRef = useRef(null)
  const params = useParams()
  const navigate = useNavigate()
  let [searchParams, setSearchParams] = useSearchParams()
  const stage = searchParams.get('stage')
  const checkType = searchParams.get('type')
  const assessmentId = searchParams.get('assessmentId')
  const isUpload = searchParams.get('isUpload')
  const assessment = searchParams.get('assessment')
  const isBack = searchParams.get('isBack')
  const [count, setCount] = useState(0)
  const [selectedRound, setSelectedRound] = useState(stage || 'all_candidates')
  const [selectedRoundType, setSelectedRoundType] = useState('')
  const [type, setType] = useState({ type: '', assessmentType: '' })
  const [currentTab, setCurrentTab] = useState('ACTIVE')
  const [currentScoreTab, setCurrentScoreTab] = useState(
    'INVITED,STARTED,COMPLETED,ABSENT'
  )
  const [bulkAction, setBulkAction] = useState(false)
  const [scheduleDrawer, setScheduleDrawer] = useState(false)
  const [createSlotDrawer, setCreateSlotDrawer] = useState(false)
  const [addReplaceDrawer, setAddReplaceDrawer] = useState(false)
  const [releaseOffer, setReleaseOffer] = useState(false)
  const [selectedCandidate, setSelectedCandidate] = useState([])
  const [selectedCandidateId, setSelectedCandidateId] = useState([])
  const [candidateIds, setCandidateIds] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingCandidate, setIsLoadingCandidate] = useState(false)
  const [candidateDeatils, setCandidateDeatils] = useState({})
  const [candidateScoreDeatils, setCandidateScoreDeatils] = useState({})
  const [currentPage, setCurrentPage] = useState(0)
  const [currentScorePage, setCurrentScorePage] = useState(0)
  const [searchScoreValue, setSearchScoreValue] = useState('')
  const [scoreBy, setScoreBy] = useState('')
  const [status, setStatus] = useState('ACTIVE')
  const [scoreStatus, setScoreStatus] = useState(
    'INVITED,STARTED,COMPLETED,ABSENT'
  )
  const [searchValue, setSearchValue] = useState('')
  const [sortBy, setSortBy] = useState('')
  const [addRoundDrawer, setAddRoundDrawer] = useState('')
  const [tabNames, setTabNames] = useState([])
  const [shortListDrawer, setShortListDrawer] = useState(false)
  const [panelValue, setPanelValue] = useState('all')
  const [candidateRating, setCandidateRating] = useState([])
  const [interviewRound, setInterviewRound] = useState([])
  const [college, setCollege] = useState([])
  const [collegeSearch, setCollegeSearch] = useState('')
  const [checkedKeys, setCheckedKeys] = useState([])
  const [checkedIds, setCheckedIds] = useState([])
  const [filterStatus, setFilterStatus] = useState('ACTIVE')
  const [selectedIds, setSelectedIds] = useState('')
  const [addInterviewerDrawer, setAddInterviewerDrawer] = useState(false)
  const [candidateInfoData, setCandidateInfoData] = useState({})
  const [interviewer, setInterviewer] = useState('')
  const [roundConfromDrawer, setRoundConfromDrawer] = useState(false)
  const [sortedItems, setSortedItems] = useState([])
  const [scorePayload, setScorePayload] = useState({})
  const [isEditRound, setIsEditRound] = useState(false)
  const [addRoundDrawerList, setAddRoundDrawerList] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isEditCondition, setIsEditCondition] = useState(false)
  const [interViewData, setInterViewData] = useState([])
  const [roundInfo, setRoundInfo] = useState()
  const [isCandDrawer, setIsCandDrawer] = useState(false)
  const [searchName, setSearchName] = useState('')
  const [topicsPayload, setTopicsPayload] = useState({})
  const [filter, setFilter] = useState([])
  const [panelData, setPanelData] = useState('')
  const onEditClick = (event, type) => {
    if (type !== 'delete') {
      setInterviewer(true)

      if (type !== 'edit') {
        setIsEditRound(false)
      } else {
        setIsEditRound(true)
        setIsEditCondition(true)
      }

      if (isEditRound || type == 'edit') {
        setAddRoundDrawer(true)
        setRoundInfo(event)
      } else {
        setAddRoundDrawer(false)
      }
    } else {
      handleDelete(event)
    }
  }

  const handleDelete = round => {
    setSortedItems(sortedItems.filter(item => item !== round))
    if (sortedItems?.length === 0) {
      setAddRoundDrawer(true)
    }
  }

  function isObject(value) {
    return typeof value === 'object' && value !== null
  }

  const onTabChange = key => {
    setStatus(key)
    // setFilterStatus(key)
    setCurrentTab(key)
    setTabNames(key)
    setScoreStatus(key)
    setSelectedCandidateId([])
    setSelectedCandidate([])
    setSearchValue('')
    setSearchScoreValue('')
    setCurrentPage(0)
    setCount(count + 1)
    setSelectedIds([])
    setPanelValue('all')
    setPanelData('')
  }
  const onScoreTabChange = key => {
    setScoreStatus(key)
    setFilterStatus('')
    setCurrentScoreTab(key)
    setTabNames(key)
    setIsLoadingCandidate(true)
    setCandidateScoreDeatils({})
    setSearchScoreValue('')
    setCurrentScorePage(0)
    setFilter([])
    setCount(count + 1)
    setSelectedIds([])
    setPanelValue('all')
    setPanelData('')
  }
  const onRoleChange = roleId => {
    navigate(`/expcandidates/${params?.expcandidatesId}/role/${roleId}`)
  }

  const getCandidateList = async () => {
    setIsLoading(true)
    let response = await getNewDriveFreshersList({
      driveId: params?.expcandidatesId,
      roleId: params?.roleId,
      currentPage: currentPage,
      searchValue,
      sortBy,
      status,
      stage,
      candidateRating,
      checkedIds,
      college,
      rolesMetrics,
      scorePayload,
      panelValue,
    })
    if (response?.status >= 200 && response?.status <= 300) {
      setCandidateDeatils(response?.data?.data || [])
      setIsLoading(false)
      setSelectedCandidateId([])
    }
  }

  const getCandidateScore = async () => {
    const currentPage = currentScorePage
    const searchValue = searchScoreValue
    const sortBy = scoreBy
    const status = scoreStatus
    setCandidateScoreDeatils([])
    setIsLoadingCandidate(true)

    let response = await getCandidateScoreList({
      driveId: params?.expcandidatesId,
      roleId: params?.roleId,
      currentPage,
      searchValue,
      sortBy,
      status,
      stage,
      candidateRating,
      checkedIds,
      college,
      rolesMetrics,
      topicsPayload,
      filter,
    })
    if (response?.status >= 200 && response?.status <= 300) {
      setCandidateScoreDeatils(response?.data?.data || [])
      setIsLoadingCandidate(false)
      setSelectedCandidateId([])
    } else {
      setIsLoadingCandidate(false)
    }
  }
  useEffect(() => {
    if (JSON.parse(isUpload)) {
      getCandidateScore()
    }
  }, [
    isUpload,
    params,
    currentScorePage,
    searchScoreValue,
    scoreBy,
    searchName,
    scoreStatus,
    stage,
    rolesMetrics,
    topicsPayload,
    filter,
  ])
  const getInterViewLocationChange = async () => {
    setIsLoading(true)
    let response = await getInterViewLocation()
    if (response?.status >= 200 && response?.status <= 300) {
      setInterViewData(response?.data?.data?.list || [])
      setIsLoading(false)
    }
  }

  const openCandidateDrawer = () => {
    setIsCandDrawer(true)
  }
  const menu = (
    <ActionMenu
      marginTop={'-40px'}
      items={[
        {
          key: 'interview',
          label: <ItemText>Manage Interview Rounds </ItemText>,
          onClick: () => onEditClick(),
        },

        {
          key: 'documents',
          label: <ItemText>Candidate Documents</ItemText>,
          onClick: () => openCandidateDrawer(),
        },
      ]}
    />
  )
  const getGDList = () => {
    getGroupDiscussionList(
      params?.roleId,
      params?.expcandidatesId,
      stage,
      status === 'ACTIVE' ? 'ACTIVE' : status,
      currentPage
    )
  }

  useEffect(() => {
    getCandidateList()
  }, [
    params,
    currentPage,
    searchValue,
    sortBy,
    status,
    stage,
    rolesMetrics,
    panelValue,
  ])

  useEffect(() => {
    getDriveRoleMetrics(params?.expcandidatesId)
    getRoleMetrics(params?.expcandidatesId, params?.roleId)
    getIndidualDriveData(params?.roleId)

    getDegreeAndDepartMent(params?.roleId)
    getSingleRoleData(0,params?.roleId)
    getRoleRounds(params?.roleId)
    getNewDriveStatus(params?.expcandidatesId, params?.roleId)
  }, [params?.expcandidatesId, params?.roleId])

  useEffect(() => {
    setSortedItems([...(roleRoundsList || [])])
  }, [roleRoundsList])

  useEffect(() => {
    let candidateStage =
      stage === 'all_candidates' ? candidateInfoData?.stage : stage
    const selectedRoundObj = rolesMetrics[0]?.rounds.filter(round => {
      if (round?.roundName === candidateStage) return round
    })[0]
    setSelectedRoundType(selectedRoundObj)
    if (selectedRoundObj?.type === 'GROUP' && status !== 'SHORTLISTED')
      getGDList()
  }, [
    params?.expcandidatesId,
    params?.roleId,
    stage,
    rolesMetrics,
    params,
    currentPage,
    candidateInfoData,
    status,
    panelValue,
  ])
  useEffect(() => {
    tableRef.current.scrollIntoView({
      behavior: 'smooth',
    })
  }, [currentPage, currentScorePage])

  useEffect(() => {
    getcollegeList(params?.expcandidatesId, params?.roleId, collegeSearch)
  }, [params?.expcandidatesId, params?.roleId, collegeSearch])

  useEffect(() => {
    setSelectedRound(stage || 'all_candidates')
    setInterviewRound([stage || 'all_candidates'])
    getNewDriveScore(params?.expcandidatesId, params?.roleId)
  }, [stage])

  const paths = [
    {
      from: 'Experienced Candidate',
      path: '/expcandidates',
    },
    {
      from: 'Experienced Candidate - Role View',
      path: `/expcandidates/${params?.expcandidatesId}/role/${params.roleId}`,
    },
  ]
  const scoreTabList = [
    {
      tabName: 'Total Experienced Candidate',
      count: candidateScoreDeatils?.totalCandidateCount || 0,
      key: 'INVITED,STARTED,COMPLETED,ABSENT',
    },
    {
      tabName: 'Invited',
      count: candidateScoreDeatils?.invitedCount || 0,
      key: 'INVITED',
    },
    {
      tabName: 'Assessment Started',
      count: candidateScoreDeatils?.startedCount || 0,
      key: 'STARTED',
    },
    {
      tabName: 'Assessment Completed',
      count: candidateScoreDeatils?.completedCount || 0,
      key: 'COMPLETED',
    },
    {
      tabName: 'Absent',
      count: candidateScoreDeatils?.absentCount || 0,
      key: 'ABSENT',
    },
  ]
  const tabList = [
    {
      tabName: 'Active',
      count: candidateDeatils?.activeCount,
      key: 'ACTIVE',
    },
    {
      tabName: 'Schedule',
      count: candidateDeatils?.scheduleCount,
      key: 'SCHEDULED,TO_BE_SCHEDULED',
    },
    ...(checkType !== 'ASSESMENT'
      ? [
          {
            tabName: 'Reschedule',
            count: candidateDeatils?.rescheduleCount,
            key: 'RESCHEDULED,RESCHEDULE',
          },
          {
            tabName: 'Reschedule Request',
            count: candidateDeatils?.rescheduleRequestCount,
            key: 'RESCHEDULE_REQUESTED',
          },
        ]
      : []),
    {
      tabName: 'Held to compare',
      count: candidateDeatils?.heldtoCompareCount,
      key: 'HELD_TO_COMPARE',
    },
    {
      tabName: 'Rejected',
      count: candidateDeatils?.rejectedCount,
      key: 'REJECTED',
    },
    ...(checkType !== 'ASSESMENT'
      ? [
          {
            tabName: 'Absent',
            count: candidateDeatils?.absentCount,
            key: 'ABSENT',
          },
        ]
      : []),
  ]

  const tabDeatils =
    stage === 'offer'
      ? [
          {
            tabName: 'Active',
            count: candidateDeatils?.activeOfferCount,
            key: 'ACTIVE',
          },
          {
            tabName: 'Released',
            count: candidateDeatils?.offerRleasedCount,
            key: 'RELEASED',
          },
          {
            tabName: 'Accepted',
            count: candidateDeatils?.offerAcceptedCount,
            key: 'ACCEPTED',
          },
          {
            tabName: 'Rejected',
            count: candidateDeatils?.offerRejectedCount,
            key: 'REJECTED',
          },
        ]
      : checkType === 'EXTERNAL_ASSESMENT'
      ? [
          {
            tabName: 'Active',
            count: candidateDeatils?.activeCount,
            key: 'ACTIVE',
          },
          {
            tabName: 'Schedule',
            count: candidateDeatils?.scheduleCount,
            key: 'SCHEDULED,TO_BE_SCHEDULED',
          },
          {
            tabName: 'Rejected',
            count: candidateDeatils?.rejectedCount,
            key: 'REJECTED',
          },
        ]
      : stage === 'all_candidates'
      ? []
      : tabList

  const handleSubmit = async () => {
    let payload = {
      rounds: sortedItems,
    }
    updateRoleRounds(params?.expcandidatesId, params?.roleId, payload)
    setInterviewer(false)
    setRoundConfromDrawer(true)
    setIsEditRound(false)
    setIsEdit(false)
  }

  useEffect(() => {
    getInterViewLocationChange()
  }, [])

  const onShortlistButtonClick = async () => {
    const result = selectedIds.map(studentId => ({ studentId }))
    let response = await postShortlistCandidates(assessmentId, result)
    if (response?.status >= 200 && response?.status <= 300) {
      SuccessMessage('Shortlisted Successfully')
      setIsLoading(false)
      getCandidateScore()
      getDriveRoleMetrics(params?.expcandidatesId)
      getRoleMetrics(params?.expcandidatesId, params?.roleId)
      setSelectedIds([])
    } else {
      setIsLoading(false)
      ErrorMessage(response?.response?.data?.message)
    }
  }

  const onDrawerOpen = () => {
    setShortListDrawer(true)
  }

  const onClickLink = (e, content) => {
    e.preventDefault()
    let data = rolesMetrics?.[0]?.rounds?.find(
      item => item.roundName === selectedRound
    )
    setSearchParams({
      ...searchParams,
      stage: data?.roundName,
      type: data?.type ? data?.type : 'all',
      assessment: data?.assesmentType ? data?.assesmentType : 'Test Gorilla',
      isUpload: isObject(data?.extAssmnts),
      assessmentId: data?.extAssmnts?.id,
      isBack: content !== 'score',
    })
  }

  const permission = useSelector(state => state?.auth?.permissions)

  const subEvents = permittedSubEvents(
    permission,
    'Evaluation Process - Experienced Candidate',
    'Drive Info'
  )
  const dropdownContainer = React.useRef(null)
  return (
    <SectionWrapper>
      <PaddedDiv column ref={tableRef}>
        <TopHeader row spaceBetween alignCenter>
          <LeftSection centerVertically>
            <Link
              to={`/expcandidates/${params?.expcandidatesId}/role/${params.roleId}`}
            >
              <LeftArrow />
            </Link>
            <SectionName column>
              <RoutePath
                fromArr={paths}
                on={
                  rolesMetrics[0]?.roleName?.charAt(0)?.toUpperCase() +
                  rolesMetrics[0]?.roleName?.slice(1)
                }
                path={`/expcandidates/${params?.expcandidatesId}/role/${params.roleId}`}
              />
              <DropDown
                overlay={roleMenu(onRoleChange, driveRolesMetrics)}
                trigger={
                  checkType === 'EXTERNAL_ASSESMENT' && JSON.parse(isUpload)
                    ? ''
                    : ['click']
                }
                getPopupContainer={() => dropdownContainer.current}
              >
                <RoleNameFlex ref={dropdownContainer}>
                  <RoleNameDiv>{rolesMetrics[0]?.roleName}</RoleNameDiv>
                  <div>
                    <DownArrowSolid />
                  </div>
                  {JSON.parse(isUpload) &&
                    checkType === 'EXTERNAL_ASSESMENT' &&
                    JSON.parse(isBack) !== true && (
                      <EmptyElement
                        style={{
                          color: 'blue',
                          fontSize: '13px',
                          justifyContent: 'center',
                          alignItems: 'center',
                          display: 'flex',
                          fontWeight: 400,
                          textDecoration: 'underline',
                          marginLeft: '15px',
                        }}
                        onClick={e => onClickLink(e, 'previous')}
                      >
                        Go to Active Page
                      </EmptyElement>
                    )}
                  {JSON.parse(isUpload) &&
                    checkType === 'EXTERNAL_ASSESMENT' &&
                    JSON.parse(isBack) && (
                      <EmptyElement
                        style={{
                          color: 'blue',
                          fontSize: '13px',
                          justifyContent: 'center',
                          alignItems: 'center',
                          display: 'flex',
                          fontWeight: 400,
                          textDecoration: 'underline',
                          marginLeft: '15px',
                        }}
                        onClick={e => onClickLink(e, 'score')}
                      >
                        Go to Score Page
                      </EmptyElement>
                    )}
                </RoleNameFlex>
              </DropDown>
            </SectionName>
          </LeftSection>
          {driveData?.driveMode === 'VIRTUAL_DRIVE' &&
          driveData?.corporateStatus === 'CANCELLED' ? null : (
            <TopEndFlex alignCenter>
              &nbsp;
              {selectedRound !== 'all_candidates' &&
                selectedCandidateId?.length > 0 &&
                status?.includes('SHORTLISTED') &&
                stage === 'offer' &&
                subEvents?.includes('BULK ACTION') && (
                  <BulkUploadDiv>
                    <Button.Primary
                      onClick={() => {
                        setBulkAction(true)
                      }}
                      width="117px"
                      height="38px"
                      disable={selectedCandidateId?.length <= 0}
                      text="Bulk Action"
                    />
                  </BulkUploadDiv>
                )}
              {subEvents?.includes('DOWNLOAD/UPLOAD') && (
                <DownlaodUpload
                  driveId={params?.expcandidatesId}
                  noNeedRole={true}
                  roleId={params?.roleId}
                  getCandidateList={getCandidateList}
                  getGDList={getGDList}
                  stage={stage}
                  type={type}
                  fileUpload={fileUpload}
                  checkType={checkType}
                  candidateDeatils={candidateDeatils}
                  assessment={assessment}
                  setSearchParams={setSearchParams}
                  searchParams={searchParams}
                  rolesMetrics={rolesMetrics?.[0]?.rounds?.find(
                    item => item.roundName === selectedRound
                  )}
                />
              )}
              &nbsp;
              <Dropdown overlay={menu} trigger={['click']}>
                <EmptyAnchor onClick={e => e.preventDefault()}>
                  <SmallButtons
                    width={'40px'}
                    height={'38px'}
                    icon={<VerticalThreeDots />}
                  />
                </EmptyAnchor>
              </Dropdown>
            </TopEndFlex>
          )}
        </TopHeader>
        <Metrics
          rolesMetrics={rolesMetrics}
          selectedRound={selectedRound}
          setSelectedRound={setSelectedRound}
          setSearchParams={setSearchParams}
          setCurrentPage={setCurrentPage}
          setSelectedCandidateId={setSelectedCandidateId}
          setSelectedCandidate={setSelectedCandidate}
          setCurrentTab={setCurrentTab}
          setStatus={setStatus}
          setFilterStatus={setFilterStatus}
          setType={setType}
          setCurrentScoreTab={setCurrentScoreTab}
          setScoreStatus={setScoreStatus}
          setSearchValue={setSearchValue}
          setSearchScoreValue={setSearchScoreValue}
          setCurrentScorePage={setCurrentScorePage}
          setPanelData={setPanelData}
          setPanelValue={setPanelValue}
          setScorePayload={setScorePayload}
        />
        {JSON.parse(isUpload) &&
          checkType === 'EXTERNAL_ASSESMENT' &&
          !JSON.parse(isBack) && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'end',
                position: 'relative',
                right: '60px',
                top: '-25px',
                zIndex: 1,
              }}
            >
              <Button.Primary
                width="117px"
                height="38px"
                onClick={() => {
                  onDrawerOpen()
                }}
                disable={selectedIds?.length < 1}
                text="Shortlist"
              />
            </div>
          )}
        {JSON.parse(isUpload) &&
        checkType === 'EXTERNAL_ASSESMENT' &&
        !JSON.parse(isBack) ? (
          <div style={{ display: 'flex', marginTop: '-63px' }}>
            <StyledTab
              onChange={onScoreTabChange}
              width={'100%'}
              activeKey={currentScoreTab}
              defaultActiveKey={currentScoreTab}
            >
              {scoreTabList?.map(data => {
                return (
                  <TabPane
                    tab={
                      <Fragment>
                        {data?.tabName}
                        <CandidatesSpan>
                          {getZeroBeforeInt(data?.count)}
                        </CandidatesSpan>
                      </Fragment>
                    }
                    key={data?.key}
                  >
                    <ExternalDriveTable
                      isVisible={
                        scoreStatus == 'INVITED,STARTED,COMPLETED,ABSENT'
                      }
                      count={count}
                      filter={filter}
                      setFilter={setFilter}
                      isLoading={isLoadingCandidate}
                      selectedIds={selectedIds}
                      getDriveRoleMetrics={getDriveRoleMetrics}
                      getRoleMetrics={getRoleMetrics}
                      searchScoreValue={searchScoreValue}
                      setSearchScoreValue={setSearchScoreValue}
                      currentScorePage={currentScorePage}
                      setCurrentScorePage={setCurrentScorePage}
                      setScoreSortBy={setScoreBy}
                      topicsPayload={topicsPayload}
                      setTopicsPayload={setTopicsPayload}
                      candidateScoreDeatils={candidateScoreDeatils}
                      setSelectedIds={setSelectedIds}
                      onShortlistButtonClick={onShortlistButtonClick}
                      getTopicsList={getTopicsList}
                      assessmentId={assessmentId}
                      postPassingScore={postPassingScore}
                      getCandidateScore={getCandidateScore}
                      setSearchName={setSearchName}
                      searchName={searchName}
                      driveData={driveData}
                      scheduleDrawer={scheduleDrawer}
                      setScheduleDrawer={setScheduleDrawer}
                      createSlotDrawer={createSlotDrawer}
                      setCreateSlotDrawer={setCreateSlotDrawer}
                      candidateDetails={candidateDetails}
                      rolesMetrics={rolesMetrics}
                      candidateInterviewDetails={candidateInterviewDetails}
                      candidateInfoData={candidateInfoData}
                      updateInterviewStatus={updateInterviewStatus}
                      driveId={params?.expcandidatesId}
                      roleId={params?.roleId}
                      getCandidateList={getCandidateList}
                      selectedRoundType={selectedRoundType}
                      loading={isLoading}
                      setSelectedCandidate={setSelectedCandidate}
                      setSelectedCandidateId={setSelectedCandidateId}
                      getSingleCandidateInterviewDetails={
                        getSingleCandidateInterviewDetails
                      }
                      setReleaseOffer={setReleaseOffer}
                      getCandidateDetails={getCandidateDetails}
                      isUpload={isUpload}
                      subEvents={subEvents}
                    />
                  </TabPane>
                )
              })}
            </StyledTab>
          </div>
        ) : stage === 'all_candidates' ? (
          <div style={{ marginTop: '3em' }}>
            <IndividualDriveTable
              setPanelData={setPanelData}
              panelData={panelData}
              panelValue={panelValue}
              setPanelValue={setPanelValue}
              selectedCandidate={selectedCandidate}
              getPanelList={getPanelList}
              getNewIndividualDriveStatus={getNewIndividualDriveStatus}
              setScorePayload={setScorePayload}
              newDriveStatusData={newDriveStatusData}
              newDriveScoreData={newDriveScoreData}
              filter={filter}
              setFilter={setFilter}
              stages={stage}
              singleRoleData={singleRoleData}
              driveData={driveData}
              scheduleDrawer={scheduleDrawer}
              setScheduleDrawer={setScheduleDrawer}
              candidateDeatils={candidateDeatils}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setSearchValue={setSearchValue}
              searchValue={searchValue}
              setSortBy={setSortBy}
              isLoading={isLoading}
              candidateRating={candidateRating}
              setCandidateRating={setCandidateRating}
              interviewRound={interviewRound}
              setInterviewRound={setInterviewRound}
              getCandidateList={getCandidateList}
              rolesMetrics={rolesMetrics}
              degreeList={degreeList}
              setSearchParams={setSearchParams}
              checkedKeys={checkedKeys}
              setCheckedKeys={setCheckedKeys}
              checkedIds={checkedIds}
              setCheckedIds={setCheckedIds}
              setSelectedCandidateId={setSelectedCandidateId}
              setSelectedCandidate={setSelectedCandidate}
              collegeList={collegeList}
              college={college}
              setCollege={setCollege}
              setCollegeSearch={setCollegeSearch}
              getCandidateDetails={getCandidateDetails}
              candidateDetails={candidateDetails}
              getSingleCandidateInterviewDetails={
                getSingleCandidateInterviewDetails
              }
              driveId={params?.expcandidatesId}
              roleId={params?.roleId}
              candidateInterviewDetails={candidateInterviewDetails}
              updateInterviewStatus={updateInterviewStatus}
              selectedRoundType={selectedRoundType}
              getGroupCandidateList={getGroupCandidateList}
              groupList={groupList}
              groupCandidateList={groupCandidateList}
              status={status}
              stage={stage}
              candidateInfoData={candidateInfoData}
              setCandidateInfoData={setCandidateInfoData}
              setStatus={setStatus}
              filterStatus={filterStatus}
              setFilterStatus={setFilterStatus}
              getRoleMetrics={getRoleMetrics}
              selectedCandidateId={selectedCandidateId}
              setReleaseOffer={setReleaseOffer}
              currentTab={currentTab}
              getNewDriveFreshersList={getNewDriveFreshersList}
              newFreshersListData={newFreshersListData}
            />
          </div>
        ) : (
          <StyledTab
            disabled={isLoading}
            onChange={onTabChange}
            width={'100%'}
            activeKey={currentTab}
            defaultActiveKey={currentTab}
            height={stage === 'all_candidates'}
          >
            {tabDeatils?.map(data => {
              return (
                <TabPane
                  disabled={isLoading}
                  tab={
                    <Fragment>
                      {data?.tabName}
                      <CandidatesSpan>
                        {getZeroBeforeInt(data?.count)}
                      </CandidatesSpan>
                    </Fragment>
                  }
                  key={data?.key}
                >
                  <IndividualDriveTable
                    setPanelData={setPanelData}
                    panelData={panelData}
                    panelValue={panelValue}
                    setPanelValue={setPanelValue}
                    selectedCandidate={selectedCandidate}
                    getPanelList={getPanelList}
                    getNewIndividualDriveStatus={getNewIndividualDriveStatus}
                    setScorePayload={setScorePayload}
                    newDriveStatusData={newDriveStatusData}
                    newDriveScoreData={newDriveScoreData}
                    getNewDriveFreshersList={getNewDriveFreshersList}
                    newFreshersListData={newFreshersListData}
                    filter={filter}
                    setFilter={setFilter}
                    stages={stage}
                    singleRoleData={singleRoleData}
                    driveData={driveData}
                    scheduleDrawer={scheduleDrawer}
                    setScheduleDrawer={setScheduleDrawer}
                    candidateDeatils={candidateDeatils}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    setSearchValue={setSearchValue}
                    searchValue={searchValue}
                    setSortBy={setSortBy}
                    isLoading={isLoading}
                    candidateRating={candidateRating}
                    setCandidateRating={setCandidateRating}
                    interviewRound={interviewRound}
                    setInterviewRound={setInterviewRound}
                    getCandidateList={getCandidateList}
                    rolesMetrics={rolesMetrics}
                    degreeList={degreeList}
                    setSearchParams={setSearchParams}
                    checkedKeys={checkedKeys}
                    setCheckedKeys={setCheckedKeys}
                    checkedIds={checkedIds}
                    setCheckedIds={setCheckedIds}
                    setSelectedCandidateId={setSelectedCandidateId}
                    setSelectedCandidate={setSelectedCandidate}
                    collegeList={collegeList}
                    college={college}
                    setCollege={setCollege}
                    setCollegeSearch={setCollegeSearch}
                    getCandidateDetails={getCandidateDetails}
                    candidateDetails={candidateDetails}
                    getSingleCandidateInterviewDetails={
                      getSingleCandidateInterviewDetails
                    }
                    driveId={params?.expcandidatesId}
                    roleId={params?.roleId}
                    candidateInterviewDetails={candidateInterviewDetails}
                    updateInterviewStatus={updateInterviewStatus}
                    selectedRoundType={selectedRoundType}
                    getGroupCandidateList={getGroupCandidateList}
                    groupList={groupList}
                    groupCandidateList={groupCandidateList}
                    status={status}
                    stage={stage}
                    candidateInfoData={candidateInfoData}
                    setCandidateInfoData={setCandidateInfoData}
                    setStatus={setStatus}
                    filterStatus={filterStatus}
                    setFilterStatus={setFilterStatus}
                    getRoleMetrics={getRoleMetrics}
                    selectedCandidateId={selectedCandidateId}
                    setReleaseOffer={setReleaseOffer}
                    currentTab={currentTab}
                    subEvents={subEvents}
                  />
                </TabPane>
              )
            })}
          </StyledTab>
        )}
      </PaddedDiv>
      <ManageInterviewDrawer
        interviewer={interviewer}
        setInterviewer={setInterviewRound}
        setAddRoundDrawer={setAddRoundDrawer}
        addRoundDrawer={addRoundDrawer}
        setRoundConfromDrawer={setRoundConfromDrawer}
        roundConfromDrawer={roundConfromDrawer}
        sortedItems={sortedItems}
        setSortedItems={setSortedItems}
        onEditClick={onEditClick}
        setAddRoundDrawerLsit={setAddRoundDrawerList}
        AddRoundDrawerList={addRoundDrawerList}
        handleDelete={handleDelete}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        onClose={() => {
          setInterviewer(false)
          setAddRoundDrawer(false)
        }}
        handleSubmit={handleSubmit}
        getRoleMetrics={getRoleMetrics}
        getDriveRoleMetrics={getDriveRoleMetrics}
        expcandidatesId={params?.expcandidatesId}
        getDriveRoleCandidatesList={getDriveRoleCandidatesList}
        driveId={params?.expcandidatesId}
        roleId={params?.roleId}
        currentPage={currentPage}
        stage={stage}
        isEditCondition={isEditCondition}
        setIsEditCondition={setIsEditCondition}
      />
      <AddRoundForm
        setAddRoundDrawer={setAddRoundDrawer}
        addRoundDrawer={addRoundDrawer}
        setAddRoundDrawerLsit={setAddRoundDrawerList}
        AddRoundDrawerList={addRoundDrawerList}
        setIsEdit={setIsEdit}
        setInterviewer={setInterviewer}
        setSortedItems={setSortedItems}
        sortedItems={sortedItems}
        setRoundInfo={setRoundInfo}
        roundInfo={roundInfo}
        isEditRound={isEditRound}
        setIsEditRound={setIsEditRound}
      />
      <CandidateDetailDrawer
        isCandDrawer={isCandDrawer}
        setIsCandDrawer={setIsCandDrawer}
        canditateDocumentList={canditateDocumentList}
        getCandidateDocumentsList={getCandidateDocumentsList}
        getCandidateDocumentsMetrices={getCandidateDocumentsMetrices}
        canditateDocumentMetrices={canditateDocumentMetrices}
        driveId={params?.expcandidatesId}
        roleId={params?.roleId}
        loading={isLoading}
        setLoading={setIsLoading}
      />
      <BulkActionDrawer
        bulkAction={bulkAction}
        createSlotDrawer={createSlotDrawer}
        setCreateSlotDrawer={setCreateSlotDrawer}
        setBulkAction={setBulkAction}
        scheduleDrawer={scheduleDrawer}
        setScheduleDrawer={setScheduleDrawer}
        releaseOffer={releaseOffer}
        setReleaseOffer={setReleaseOffer}
        selectedCandidateId={selectedCandidateId}
        selectedCandidate={selectedCandidate}
        rolesMetrics={rolesMetrics}
        createInterview={createInterview}
        driveId={params?.expcandidatesId}
        roleId={params?.roleId}
        driveInterViewerList={driveInterViewerList}
        getDriveInterviewerList={getDriveInterviewerList}
        selectedRound={selectedRound}
        driveData={driveData}
        interViewerList={interViewerList}
        selectedRoundType={selectedRoundType}
        candidateDeatils={candidateDeatils}
        candidateInfoData={candidateInfoData}
        getCandidateList={getCandidateList}
        getRoleMetrics={getRoleMetrics}
        setSelectedCandidateId={setSelectedCandidateId}
        setSelectedCandidate={setSelectedCandidate}
        getCities={getCities}
        cityList={cityList}
        releaseOfferAPI={releaseOfferAPI}
        stage={stage}
        singleRoleData={singleRoleData}
        getRequestDocument={getRequestDocument}
        requestDocumentList={requestDocumentList}
        requestCandidateDocuments={requestCandidateDocuments}
        getInterViewLocation={getInterViewLocation}
        interViewData={interViewData}
        singleLocationData={singleLocationData}
        getListOfCountries={getListOfCountries}
        getListOfStates={getListOfStates}
        getListOfCities={getListOfCities}
        listOfCountries={listOfCountries}
        listOfStates={listOfStates}
        listOfCities={listOfCities}
        getCorporateLocationsList={getCorporateLocationsList}
        corporateLocationsList={corporateLocationsList}
        deleteLocationAPI={deleteLocationAPI}
        getLocationDetails={getLocationDetails}
        addCorporateBranch={addCorporateBranch}
        setCandidateIds={setCandidateIds}
        candidateIds={candidateIds}
        tabNames={tabNames}
      />
      {addInterviewerDrawer && (
        <AddInterviewer
          addInterviewerDrawer={addInterviewerDrawer}
          setAddInterviewerDrawer={setAddInterviewerDrawer}
          getInterviewerList={getInterviewerList}
          getDriveInterviewerList={getDriveInterviewerList}
          interViewerList={interViewerList}
          driveInterViewerList={driveInterViewerList}
          driveId={params?.expcandidatesId}
          addInterviewer={addInterviewer}
          deleteInterviewer={deleteInterviewer}
          updateInterview={updateInterview}
          setAddReplaceDrawer={setAddReplaceDrawer}
          addReplaceDrawer={addReplaceDrawer}
        />
      )}
      <ShortListDrawer
        selectedIds={selectedIds}
        setShortListDrawer={setShortListDrawer}
        shortListDrawer={shortListDrawer}
        onShortlistButtonClick={onShortlistButtonClick}
      />
    </SectionWrapper>
  )
}

export default ViewIndividualDrive
